import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";
import { globalAlert } from "../../actions/commonActions";
import { SERVICE_AUDIENCES } from "../../admin/_lmsActions";

const DISTRICTS = [
  "Basildon",
  "Braintree",
  "Brentwood",
  "Castle Point",
  "Chelmsford",
  "Colchester",
  "Epping Forest",
  "Harlow",
  "Maldon",
  "Rochford",
  "Tendring",
  "Uttlesford",
  "Other",
];

// Add a single learner. Returns the create payload (matching POST /learners)
// to the parent, which performs the API call.
const LmsLearnerModal = (props) => {
  const { t } = useTranslation();
  const { open, closeModal } = props;
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    jobTitle: "",
    learnerOrganisation: "",
    serviceAudience: "ESHS",
    district: "",
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const validEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const handleSubmit = (ev) => {
    ev.preventDefault();
    if (!form.firstName?.trim()) {
      globalAlert("error", t("admin.lms.learners.nameRequired"));
      return;
    }
    if (!validEmail(form.email)) {
      globalAlert("error", t("admin.lms.learners.emailInvalid"));
      return;
    }
    if (!form.serviceAudience) {
      globalAlert("error", t("admin.lms.learners.serviceRequired"));
      return;
    }
    closeModal({
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      email: form.email.trim(),
      jobTitle: form.jobTitle.trim(),
      learnerOrganisation: form.learnerOrganisation.trim(),
      serviceAudience: form.serviceAudience,
      ...(form.district ? { district: form.district } : {}),
    });
  };

  return (
    <Modal
      showCloseIcon
      classNames={{ modal: "admin-modal", root: "modal-own-wrapper" }}
      open={open}
      onClose={() => closeModal(null)}
      center
    >
      <div>
        <p className="admin-banner">{t("admin.lms.learners.addButton")}</p>
      </div>
      <form className="form-own px-3" onSubmit={handleSubmit}>
        <div className="row">
          <div className="form-own-group col-md-6">
            <label className="form-own-label">
              {t("admin.lms.learners.firstName")} *
            </label>
            <input
              className="form-control"
              value={form.firstName}
              onChange={(e) => set("firstName", e.target.value)}
            />
          </div>
          <div className="form-own-group col-md-6">
            <label className="form-own-label">
              {t("admin.lms.learners.lastName")}
            </label>
            <input
              className="form-control"
              value={form.lastName}
              onChange={(e) => set("lastName", e.target.value)}
            />
          </div>
          <div className="form-own-group col-12">
            <label className="form-own-label">{t("common.email")} *</label>
            <input
              className="form-control"
              type="email"
              value={form.email}
              onChange={(e) => set("email", e.target.value)}
            />
          </div>
          <div className="form-own-group col-md-6">
            <label className="form-own-label">
              {t("admin.lms.fields.jobTitle")}
            </label>
            <input
              className="form-control"
              value={form.jobTitle}
              onChange={(e) => set("jobTitle", e.target.value)}
            />
          </div>
          <div className="form-own-group col-md-6">
            <label className="form-own-label">
              {t("admin.lms.fields.organisation")}
            </label>
            <input
              className="form-control"
              value={form.learnerOrganisation}
              onChange={(e) => set("learnerOrganisation", e.target.value)}
            />
          </div>
          <div className="form-own-group col-md-6">
            <label className="form-own-label">
              {t("admin.lms.learners.serviceAudience")} *
            </label>
            <select
              className="form-control"
              value={form.serviceAudience}
              onChange={(e) => set("serviceAudience", e.target.value)}
            >
              {SERVICE_AUDIENCES.map((a) => (
                <option key={a} value={a}>
                  {t(`admin.lms.audience.${a}`, a)}
                </option>
              ))}
            </select>
          </div>
          <div className="form-own-group col-md-6">
            <label className="form-own-label">
              {t("admin.lms.fields.district")}
            </label>
            <select
              className="form-control"
              value={form.district}
              onChange={(e) => set("district", e.target.value)}
            >
              <option value="">{t("common.select")}</option>
              {DISTRICTS.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3" style={{ gap: 12 }}>
          <button
            type="button"
            className="btn secondary-btn btn-own-grey"
            onClick={() => closeModal(null)}
          >
            {t("common.cancel")}
          </button>
          <button type="submit" className="btn secondary-btn">
            {t("common.save")}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default LmsLearnerModal;
